/* eslint-disable react-hooks/exhaustive-deps */
import { faArrowLeft, faHardHat, faPhoneAlt } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useContext, useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import GridButton from "../../../../components/Tablet/GridButton"
import TenkosyaInfo from "../../../../components/Tablet/TenkosyaInfo"
import { 区分分類コード } from "../../../../constant/enum/codes"
import { e点呼方法区分 } from "../../../../constant/enum/unko"
import { selectModePage, selectSyainByICCardPage, selectSyainByNumberPage } from "../../../../constant/tablet/pages"
import { 区分マスタ } from "../../../../service/master/kubun/TKubun"
import KubunService from "../../../../service/master/kubun/kubunService"
import { TenkoDetailContext, TenkoHohoKubunContext, ZyomuinContext } from "../../context/context"
import { CSS_PROPERTY } from "../../cssProperties/tablet"

const SelectTenkoType = () => {
  const history = useHistory()

  const { set点呼方法区分 } = useContext(TenkoHohoKubunContext)
  const { set乗務員 } = useContext(ZyomuinContext)
  const { set点呼明細 } = useContext(TenkoDetailContext)

  const [対面点呼区分, set対面点呼区分] = useState<区分マスタ>()
  const [電話点呼区分, set電話点呼区分] = useState<区分マスタ>()

  useEffect(() => {
    // 点呼明細と従業員情報を削除する
    set乗務員(undefined)
    set点呼明細(undefined)

    Promise.all([
      new KubunService().getList({
        分類コード: 区分分類コード.運行管理_勤怠.点呼方法区分,
      }),
    ]).then(async ([点呼方法区分Res]) => {
      if (点呼方法区分Res && 点呼方法区分Res.data) {
        set対面点呼区分(点呼方法区分Res.data.find((d) => d.区分コード === e点呼方法区分.対面))
        set電話点呼区分(点呼方法区分Res.data.find((d) => d.区分コード === e点呼方法区分.電話))
      }
    })
  }, [])

  const move対面 = () => {
    set点呼方法区分(対面点呼区分)
    history.push(selectSyainByICCardPage.Route.path)
  }

  const move電話 = async () => {
    set点呼方法区分(電話点呼区分)
    history.push(selectSyainByNumberPage.Route.path)
  }

  return (
    <>
      <TenkosyaInfo></TenkosyaInfo>
      <table style={{ tableLayout: "fixed", height: CSS_PROPERTY.BODY_TABLE_HEIGHT }} className="w-100 mt-3">
        <tbody>
          <tr>
            <td colSpan={2}>対面点呼ですか？　電話点呼ですか？</td>
          </tr>
          <tr>
            <td>
              <GridButton onTouchStartEventHandler={move対面}>
                <div
                  style={{
                    width: "100%",
                    margin: "auto",
                    textAlign: "center",
                  }}>
                  <FontAwesomeIcon style={{ marginRight: "2rem" }} icon={faHardHat} />
                  <span>対面</span>
                </div>
              </GridButton>
            </td>
            <td>
              <GridButton onTouchStartEventHandler={move電話}>
                <div
                  style={{
                    width: "100%",
                    margin: "auto",
                    textAlign: "center",
                  }}>
                  <FontAwesomeIcon style={{ marginRight: "2rem" }} icon={faPhoneAlt} />
                  <span>電話</span>
                </div>
              </GridButton>
            </td>
          </tr>
          <tr>
            <td className="align-bottom" style={{ height: CSS_PROPERTY.BODY_TABLE_BUTTON_ROW_HEIGHT }}>
              <div
                onTouchStart={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  history.push(selectModePage.Route.path)
                }}
                style={{
                  backgroundColor: "white",
                  display: "flex",
                  width: "25rem",
                  fontSize: "3rem",
                  padding: "0.5rem 1rem",
                  ...CSS_PROPERTY.BORER_PROPERTIES,
                  marginBottom: "1rem",
                }}>
                <div>
                  <FontAwesomeIcon icon={faArrowLeft}></FontAwesomeIcon>
                </div>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                  }}>
                  <span>戻る</span>
                </div>
              </div>
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </>
  )
}

export default SelectTenkoType
